// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b1CN","controls":"styles_controls__BnWcI","charLimit":"styles_charLimit__3ByxY","input":"styles_input__3az4x","send":"styles_send__2XXTn"};